export default [
    {
        path      : '*',
        redirect  : {
            path : '/404'
        },
        meta      : {
            public : true,
        }
    },
    {
        path      : '/404',
        name      : 'NotFound',
        component : () => import(
            /* webpackChunkName: "routes" */
            `@/views/NotFound.vue`
        ),
        meta      : {
            public : true,
        }
    },
    {
        path      : '/403',
        name      : 'AccessDenied',
        component : () => import(
            /* webpackChunkName: "routes" */
            `@/views/Deny.vue`
        ),
        meta      : {
            public : true,
        }
    },
    {
        path      : '/500',
        name      : 'ServerError',
        component : () => import(
            /* webpackChunkName: "routes" */
            `@/views/Error.vue`
        ),
        meta      : {
            public : true,
        }
    },
    {
        path      : '/',
        name      : 'Root',
        redirect  : {
            name : 'relatorios'
        }
    },
    {
        path      : '/login',
        name      : 'Login',
        component : () => import(
            /* webpackChunkName: "routes" */
            `@/views/Login.vue`
        ),
        meta      : {
            public : true,
        }
    },
    {
        path      : '/relatorios',
        name      : 'relatorios',
        component : () => import(
            `@/views/relatorios/Relatorios.vue`
        ),
        meta      : {
            breadcrumb  : false,
            permissions : [
                'Administrador',
                'Funcionário'
            ]
        }
    },
    {
        path      : '/despesas/:uuid?',
        name      : 'despesas',
        component : () => import(
            /* webpackChunkName : "routes" */
            `@/views/despesas/Despesas.vue`
        ),
        meta      : {
            breadcrumb  : false,
            permissions : [
                'Administrador',
                'Funcionário'
            ]
        },
    },
    {
        path      : "/usuarios",
        name      : "usuarios",
        component : () => import(
            /* webpackChunkName : "routes" */
            `@/views/usuarios/Usuarios.vue`
        ),
        meta      : {
            breadcrumb  : false,
            permissions : [
                'Administrador'
            ]
        },
    },
    {
        path      : "/categorias",
        name      : "categorias",
        component : () => import(
            /* webpackChunkName: "routes" */
            `@/views/categorias/Categorias.vue`
        ),
        meta      : {
            breadcrumb  : false,
            permissions : [
                'Administrador'
            ]
        },
    },
];
